// extracted by mini-css-extract-plugin
export default {"sectionContent":"styles_sectionContent__eoiV7","itemTitle":"styles_itemTitle__rbXJg","listItem":"styles_listItem__jj4e4"};